import { IMAGE } from '../elements/assets'

export const EXPLORE_CONTENT = `
  ... on exploreContent_Entry {
    id
    typeHandle

    title

    exploreContentCards {
      id
      typeHandle

      title
      description

      ${ IMAGE }

      linkField {
        url
        title
        target
      }
    }
  }
`
